<script lang="ts" setup>
import { Button, Icon, Link } from '@brighterly/lib-lumee-ui'

import type { BannerUpsellOfferContent } from '@ts-upsell-banner/interfaces'

import { useBannerUpsellOffer } from '@composables/widgets/upsell-banner/banner-upsell-offer.hook'

import BannerUpsellOfferText from '@Atoms/UpsellBanner/BannerUpsellOfferText.vue'

defineOptions({
  name: 'BannerUpsellOffer',
})

defineProps<{
  offer: BannerUpsellOfferContent
  ctaLabel: string
  href: string
}>()

const emit = defineEmits<{
  'click:cta': []
}>()

const { setSubmit } = useBannerUpsellOffer({
  onSubmit: () => emit('click:cta'),
})
</script>

<template>
  <div class="banner-upsell-offer">
    <span class="banner-upsell-offer__mobile">
      <Link
        :href="href"
        color="inverse"
        size="lg"
        class="banner-upsell-offer__link"
        @click.prevent="setSubmit"
      >
        <BannerUpsellOfferText v-bind="offer" />
      </Link>
      <span class="banner-upsell-offer__arrow">
        <Icon
          name="arrow-right"
          weight="solid"
          size="sm"
          color="inherit"
        />
      </span>
    </span>
    <BannerUpsellOfferText
      v-bind="offer"
      class="banner-upsell-offer__text btly-text-title-l"
    />
    <span class="banner-upsell-offer__cta">
      <Button
        :text="ctaLabel"
        view="accent"
        size="sm"
        fill
        @click="setSubmit"
      />
    </span>
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Widgets/UpsellBanner/BannerUpsellOffer.scss" />
